/*import Vue from 'vue'*/
//import EventUtils from '@/utils/EventUtils.js';
//import MapUtils from '@/utils/MapUtils.js';
import { clearReplyTimeout, isSameListener, startReplyTimeout } from './ReplyTimeouts.js';

const state = {
  list: [],
  map: {},
  listeners: {},
};

const getters = {
  events_store: state => state,
};

const actions = {
  addListenerAction({ commit, state }, payload) {
    if (commit && state) {
      commit('addListener', payload);
    }
  },
  removeListenerAction({ commit, state }, eventName) {
    if (commit && state) {
      commit('removeListener', eventName);
    }
  },
};

const mutations = {
  SOCKET_ONMESSAGE(state, event) {
    if (state && event) {
      var id = event['@rid'];
      var listener = state.listeners[id];
      if (listener) {
        // A reply arrived: the deadline stops, and starts again only if more is to come.
        clearReplyTimeout(id);
        setTimeout(() => {
          // Timed out (or removed) while this reply waited: nobody is listening any more.
          if (!isSameListener(state.listeners[id], listener)) {
            return;
          }
          let eventInProgress = listener.emit(event);
          if (!eventInProgress || eventInProgress == undefined) {
            delete state.listeners[id];
          } else {
            startReplyTimeout(state.listeners, id, listener);
          }
        }, 250);
      }
    }
  },
  addListener(state, payload) {
    if (state) {
      state.listeners[payload.eventName] = payload.listener;
      // A request whose reply never comes no longer waits forever (ReplyTimeouts.js).
      startReplyTimeout(state.listeners, payload.eventName, payload.listener);
    }
  },
  removeListener(state, eventName) {
    if (state) {
      clearReplyTimeout(eventName);
      delete state.listeners[eventName];
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};